import React from "react";

const ChrWidgetContainer = (props) => {
  return (
    <div className={`d-flex flex-column white-bg border border-default ${props.className}`}>
      { props.children }
    </div>
  );
};

export default ChrWidgetContainer;
